import React from "react"
import { IconContainer } from "./styles/icon"

export default function Icon({ name, size, m, mt, mr, mb, ml, p, pt, pr, pb, pl, color, ...rest }) {
  return <IconContainer {...rest} className={name} size={size} m={m} mt={mt} mr={mr} mb={mb} ml={ml} p={p} pt={pt} pr={pr} pb={pb} pl={pl} color={color} />
}
